import React from "react";

export default function InputComponent(props) {
        return ( <div className='form-group'>
                <label id={props.id+"-label"} htmlFor={props.id}>{}</label>
                <input type="text" id={props.id} className='form-control' style={{minHeight: "42px"}} onChange={props.onChange} value={props.value} maxLength={props.size || 255 }/>
                <small id={props.id+"note"} className='form-text text-muted'>{props.hint}</small>
                <input type="hidden" id={props.id+"content"} />
                </div>
        );
}
